import {
  GET_INCOME_OPERATION_LIST_FAIL,
  GET_INCOME_OPERATION_LIST_REQUEST,
  GET_INCOME_OPERATION_LIST_SUCCESS,
  GET_SINGLE_INCOME_OPERATION_FAIL,
  GET_SINGLE_INCOME_OPERATION_REQUEST,
  GET_SINGLE_INCOME_OPERATION_SUCCESS,
} from "src/constants/types";

export const incomeOperationReducers = (state = {}, actions) => {
  const { payload } = actions;
  switch (actions.type) {
    case GET_INCOME_OPERATION_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_INCOME_OPERATION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        incomeOperationList: payload,
      };
    case GET_INCOME_OPERATION_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case GET_SINGLE_INCOME_OPERATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_INCOME_OPERATION_SUCCESS:
      return {
        ...state,
        loading: false,
        singleIncomeOperation: payload,
      };
    case GET_SINGLE_INCOME_OPERATION_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return state;
  }
};
